import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';

// Estilos
import frasesAmigaveis from '../../constants/phrases';

function FriendlyPhrase({ page = null }) {
    const location = useLocation();
    const path = location.pathname.split("/").filter(Boolean);

    const pageKey = page || path[0] || 'home';
    const frases = frasesAmigaveis[pageKey] || frasesAmigaveis['home'];

    const fraseAleatoria = useMemo(() => {
        return frases[Math.floor(Math.random() * frases.length)];
    }, [pageKey]);

    return (
        <p style={{ fontSize: '1.2rem', fontWeight: 300, margin: '0 0 0 0', fontFamily: 'Formular, sans-serif', textAlign: "left", marginLeft: "0.5rem"}}>
            {fraseAleatoria}
        </p>
    );
}

export default FriendlyPhrase;